import React, { useRef, useState, useEffect } from "react";
import "./Chatbot.css";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { apiUrl, assetsUrl } from "../../config/Config";
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import ChatOverlay from "./ChatOverlay";
import Spinner from "react-activity/dist/Spinner";
import Chart from "react-apexcharts";


const ChatBot = ({ data }) => {
  const userdata = useSelector((store) => store.userReducer.userdata);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [message, setmessage] = useState("");
  const bottomRef = useRef(null);
  const chatdata = [
    { from: "me", message: "I need more details of my social media post." },
    {
      from: "ai",
      message:
        "Analyzing your Instagram post titled *'Monsoon Vibes in Goa 🌧️🌴'*. Here's what I found: **Performance Summary:**\n- Reach: 12,530\n- Impressions: 18,900\n- Likes: 1,240\n- Comments: 86\n- Shares: 32\n- Saves: 115\n\nThis post performed 23% better than your last 5 posts.",
    },
    { from: "me", message: "What are engagement insights ?" },
    {
      from: "ai",
      message:
        "**Engagement Insights:**\n- Peak engagement was between 7 PM and 9 PM.\n- Most interactions came from age group 18-24.\n- Hashtag #GoaTravel gained 45% higher reach.",
    },
    { from: "me", message: "What are your suggestions ?" },
    {
      from: "ai",
      message:
        "**AI Suggestions:**\n1. Post more reels with monsoon travel themes.\n2. Add trending hashtags like `#TravelTuesday`, `#MonsoonMagic`.\n3. Include a call-to-action in captions (e.g., _“Tag your travel buddy!”_).",
    },
    { from: "me", message: "What are your recommendations ?" },
    {
      from: "ai",
      message:
        "**Recommendations:**\n- Try posting at 8:30 PM.\n- Collaborate with local travel influencers.\n- Use carousel posts for higher engagement.",
    },
  ];
  const [chatdatamsg, setchatdatamsg] = useState([]);
  const [highlightstext, sethighlightstext] = useState([]);
  const chatdatamsgRef = useRef([]);
  chatdatamsgRef.current = chatdatamsg;

  const highlightstextRef = useRef([]);
  highlightstextRef.current = highlightstext;

  const [highlightid, sethighlightid] = useState([]);
  const highlightidRef = useRef([]);
  highlightidRef.current = highlightid;

  const [forceupdate, setforceupdate] = useState(false);
  const [loading, setloading] = useState(false);

  const [respcategoriesarr, setrespcategoriesarr] = useState([]);
  const [respseriesarr, setrespseriesarr] = useState([]);
  const [resptype, setresptype] = useState("");
  const [respsmallexplanation, setrespsmallexplanation] = useState("");

  const [showsavereport, setshowsavereport] = useState(false);
  const [reportname, setreportname] = useState("");

  const respcategoriesarrRef = useRef();
  respcategoriesarrRef.current = respcategoriesarr;

  const respseriesarrRef = useRef();
  respseriesarrRef.current = respseriesarr;

  const resptypeRef = useRef();
  resptypeRef.current = resptype;

  const [storeresult, setstoreresult] = useState({});
  const storeresultRef = useRef({});
  storeresultRef.current = storeresult;

  const respsmallexplanationRef = useRef();
  respsmallexplanationRef.current = respsmallexplanation;


  const handlesavereportsubmit = async() => {
    var data = {
      resportname: reportname,
      gradphdata: storeresultRef.current,
    }
    console.log('storeresultRef.current data >>', data);
    const headers = {
      headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + userdata?.token,
      },
    };
    const res = await axios.post(apiUrl + 'submitaireport', data, headers);
    if (res.data.status === 'success') {
      setshowsavereport(false);
      setreportname("");
    } else if (res.data.message === 'invalid user') {
      setloading(false);
      dispatch({ type: 'userdata', payload: {} });
      navigate('/');
    }
    else {
      setloading(false);
      Swal.fire({
                          text: res.data.message,
                          icon: 'error',
                          width: '350px',
                          confirmButtonText: 'Ok',
                          confirmButtonColor: 'rgb(59, 151, 196)',
                          customClass: { popup: 'small-icon-alert' },
                      });
    }
    setloading(false);
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // optional: prevent form submit or newline
      handlepostnewmessage();
    }
  };

  const handlepostnewmessage = async() => {
    if (message) {
      // var newmessage = { from: "me", message: message };
      // var prevdata = chatdatamsgRef.current;
      // prevdata.push(newmessage);
      // setforceupdate(!forceupdate);
      // setmessage("");
      setloading(true);
      var newid = chatdatamsgRef.current?.length + 1;
      var newmessage = {id: newid, from: "me", message: message };
      var prevdata = chatdatamsgRef.current
      prevdata.push(newmessage);
      setchatdatamsg(prevdata);
      setforceupdate(!forceupdate);
      setmessage("");
      var apidata = {
        analysis: data?.analysis,
        oldmessages: prevdata,
        question: newmessage?.message,
        postid: data?.id
      };
      console.log('apidata >>', apidata);
      const headers = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + userdata?.token,
        },
      };
      const res = await axios.post(apiUrl + 'talktoexpertaidm', apidata, headers);
      if (res.data.status === 'success') {
        setloading(false);
        // var fetcheddata = res.data.allmessages;
        // setchatdatamsg(fetcheddata);
        // setforceupdate(!forceupdate);

        // var fetcheddata = res.data.allmessages;
        // setchatdatamsg(fetcheddata);
        setstoreresult(res?.data?.result);
        if(res?.data?.result?.smallexplanation) {
          var respmessage = {id: newid + 1, from: "ai", message: res?.data?.result?.smallexplanation };
          prevdata.push(respmessage);
          setchatdatamsg(prevdata);
        }
        if(res?.data?.result?.categories?.length > 0 && res?.data?.result?.series?.length > 0 && res?.data?.result?.type) {
          var response = res?.data?.result;
          const parsedSeries = response.series.map((s) => ({
            ...s,
            type: s.name.includes("%") ? "line" : "column"
          }));
          setrespseriesarr(parsedSeries);

          setrespcategoriesarr({
            chart: {
              type: "line", // base type
              height: 400,
              stacked: false
            },
            stroke: {
              width: parsedSeries.map((s) => (s.type === "line" ? 2 : 0))
            },
            xaxis: {
              categories: response.categories
            },
            yaxis: [
              {
                title: { text: "Counts" } // left axis for totals
              },
              {
                opposite: true,
                title: { text: "Percentages" } // right axis for %
              }
            ],
            tooltip: {
              shared: true,
              intersect: false
            },
            legend: {
              position: "top"
            }
          })

          setresptype("line");



          // setrespcategoriesarr(res?.data?.result?.categories);
          // setrespseriesarr(res?.data?.result?.series);
          // setresptype(res?.data?.result?.type);
        }

        

        setforceupdate(!forceupdate);
      } else if (res.data.message === 'invalid user') {
        setloading(false);
        dispatch({ type: 'userdata', payload: {} });
        navigate('/');
      }
      else {
        setloading(false);
        Swal.fire({
                            text: res.data.message,
                            icon: 'error',
                            width: '350px',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: 'rgb(59, 151, 196)',
                            customClass: { popup: 'small-icon-alert' },
                        });
      }
      setloading(false);
    } else {
    }
  };

  const checkifidexist = (id) => {
    var previds = highlightidRef.current;
    if(previds.includes(id)) {
      return true;
    } else {
      return false;
    }
  }

  // console.log('highlightidRef.current >>', highlightidRef.current);
  const updatehightlightstext = (arr, allmessages) => {
    console.log('arr >>', arr);
    var newhighlightarr = [];
    var prevarr = allmessages;
    for(var i = 0; i < prevarr?.length; i++) {
      if(arr.includes(prevarr[i]?.id)) {
        newhighlightarr.push(prevarr[i])
      }
    }
    sethighlightstext(newhighlightarr);
  }

  const updatehightlightsinserver = async(arr) => {
    var apidata = {
      aihighlights: arr,
      postid: data?.id
    };
    console.log('apidata >>', apidata);
    const headers = {
      headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + userdata?.token,
      },
    };
    const res = await axios.post(apiUrl + 'updatehightlightsinserver', apidata, headers);
    if (res.data.status === 'success') {
     
    } else if (res.data.message === 'invalid user') {
      
    }
    else {
      Swal.fire({
                          text: res.data.message,
                          icon: 'error',
                          width: '350px',
                          confirmButtonText: 'Ok',
                          confirmButtonColor: 'rgb(59, 151, 196)',
                          customClass: { popup: 'small-icon-alert' },
                      });
    }
  }



  const handlechangecheckbox = (id) => {
    var result = checkifidexist(id);
    console.log('result >>', result);
    if(result) {
      const index = highlightidRef.current.indexOf(id);
      var newarr = highlightidRef.current;
      newarr?.splice(index, 1);
      sethighlightid(newarr);
      updatehightlightstext(newarr, chatdatamsgRef?.current);
      updatehightlightsinserver(newarr);
      setforceupdate(!forceupdate);
    } else {
      var newarr = highlightidRef.current;
      newarr.push(id);
      sethighlightid(newarr);
      updatehightlightstext(newarr, chatdatamsgRef?.current);
      updatehightlightsinserver(newarr);
      setforceupdate(!forceupdate);
    }
  }

  useEffect(() => {
    console.log("component lifecycle >>");
    console.log("ChatBot data >>", data);
    var allchats = data?.allmessages ? JSON.parse(data?.allmessages) : [];
    setchatdatamsg(allchats);

    var highlightstext = data?.aihighlights
      ? JSON.parse(data?.aihighlights)
      : [];
    if(highlightstext?.length > 0) {
      sethighlightid(highlightstext);
      updatehightlightstext(highlightstext, allchats);
    } else {
      sethighlightid([]);
      sethighlightstext([]);
    }
    
  }, []);

  useEffect(() => {
    setTimeout(() => {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 2000);
    // Scroll to bottom whenever messages change
    
  }, [chatdatamsgRef.current, message]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [message])

  return (
    <div
      className=""
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
      }}
    >
      <div className="post-details-ai-box" style={{ width: "52%" }}>
        {/* {highlightstextRef?.current?.length > 0 ? (
          <>
            <h5 className="aisummarytext">AI Summary</h5>
            <div className="summarybox">
              <ol className="mt-2">
                {highlightstextRef?.current?.map((item, index) => (
                  <li key={index}>{item?.message}</li>
                ))}
              </ol>
            </div>
          </>
        ) : (
          <p className="no-summary-text">No summary data</p>
        )} */}

{
        respseriesarrRef?.current?.length > 0 ?
          <>
            <h6 className="aisummarytext">Graphical Representation</h6>
            <br />
            <Chart options={respcategoriesarrRef?.current} series={respseriesarrRef?.current} type="line" height={300} />
            {/* <div className="mt-3 savethisreportdiv">
              <p>Save this report ?</p>
              <div className="checkboxdiv">
                <input checked={showsavereport} type="checkbox" onChange={(t) => {setshowsavereport(t.target.checked)}} className="checkboxinput" />
                <p>Yes</p>
              </div>
            </div> */}
            {
              showsavereport ?
              <div className="showsavereportfield">
              <input type="text" value={reportname} onChange={(t) => {setreportname(t.target.value)}} className="form-control" placeholder="Enter Report Name" />
              <button className="btn btn-success mt-3" onClick={() => {
                handlesavereportsubmit();
              }}>Save</button>
            </div> : null
            }
            
          </>
         : null}
      </div>

      <div className="chat-bot-container" style={{ width: "45%" }}>
        <div className="chatbotparentclass">
          {/* Header */}
          <div className="chatboxheader">
            <p className="talkwithexpert">Talk With Expert</p>
          </div>

          {/* Screen */}
          <div className="chatboxscreen">
            {chatdatamsgRef.current?.map((item, index) => {
              return (
                <>
                  {item?.from == "me" ? (
                    <div className="aimessagebox memessagebox">
                      <p>{item?.message}</p>
                    </div>
                  ) : (
                    <div className="aimessageboxmaindiv">
                      <div className="aimessagebox">
                        <p>{item?.message}</p>
                      </div>
                      {/* <div className="aichatbotcheckboxdiv">
                        <input
                          type="checkbox"
                          className="aicheckbox"
                          checked={checkifidexist(item?.id)}
                          onChange={() => {
                            handlechangecheckbox(item?.id);
                          }}
                        />
                      </div> */}
                    </div>
                  )}
                </>
              );
            })}

            <div ref={bottomRef} />
          </div>

          {/* Enter Message box */}
          <div className="chatboxmessagediv">
            <div className="chatboxmessagebox">
              <input
                className="form-control chatboxmessage-input"
                value={message}
                onChange={(t) => {
                  setmessage(t.target.value);
                }}
                onKeyDown={handleKeyDown}
                placeholder="Write your query"
              />
            </div>
            <div className="chatboxsendbtndiv">
              {loading ? (
                <div className="chatboxicondiv">
                  <Spinner color="#333" size={18} className="chatbotspinner" />
                </div>
              ) : (
                <div
                  className="chatboxicondiv"
                  onClick={() => handlepostnewmessage()}
                >
                  <FontAwesomeIcon
                    icon={faPaperPlane}
                    className="chatboxicon"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatBot;
